import { RefresherEventDetail, IonRefresher, IonRefresherContent } from "@ionic/react";
import React from "react";

interface PullToRefreshProps {
  onRefresh?: () => void;
  disabled?: boolean;
}

const PullToRefresh = ({ onRefresh, disabled }: PullToRefreshProps) => {
  const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
    if (onRefresh) {
      onRefresh();
    } else {
      window.location.reload();
    }
    event.detail.complete();
  };

  return (
    <IonRefresher slot="fixed" pullMin={170} pullMax={330} disabled={disabled} onIonRefresh={handleRefresh}>
      <IonRefresherContent refreshingSpinner="circular" />
    </IonRefresher>
  );
};

export default PullToRefresh;
